module.exports = require("date-fns/locale");